import { guardMessage } from './balanceError'
import { balanceText } from './balanceI18n'

/**
 * Sep 23 — how a write on a team official's line (or a candidate) was refused, from
 * the server's answer:
 *
 *   preview_changed   422 — something moved since the preview: re-preview, show again
 *   refresh_required  409 — the row's kind is not what this page showed
 *   identity_changed  404/409 — the person may no longer have a line, or it changed
 *   own_line          403 — the payer of their own line, not a league admin (D8/D11)
 *   other             anything else — the server's own message
 */
export type OfficialWriteError =
  | 'preview_changed'
  | 'refresh_required'
  | 'identity_changed'
  | 'own_line'
  | 'other'

type ApiError = {
  status?: number
  statusCode?: number
  error_code?: string
  invalid_fields?: Record<string, string>
}

export const officialWriteError = (error: unknown): OfficialWriteError => {
  const apiError = (error ?? {}) as ApiError
  const status = apiError.status ?? apiError.statusCode

  if (apiError.invalid_fields?.preview_changed) {
    return 'preview_changed'
  }
  if (apiError.error_code === 'refresh_required') {
    return 'refresh_required'
  }
  if (apiError.error_code === 'own_line') {
    return 'own_line'
  }
  if (
    status === 404 ||
    apiError.error_code === 'identity_changed' ||
    apiError.error_code === 'official_line_exists'
  ) {
    return 'identity_changed'
  }

  return 'other'
}

/** The message a refused official write shows. */
export const officialWriteMessage = (error: unknown): string => {
  switch (officialWriteError(error)) {
    case 'preview_changed':
      return balanceText('common:balanceOfficialPreviewChanged')
    case 'refresh_required':
      return balanceText('common:balanceRefreshRequired')
    case 'identity_changed':
      return balanceText('common:balanceOfficialDetailsChanged')
    case 'own_line':
      return balanceText('common:balanceOfficialOwnLineTip')
    default:
      return guardMessage(error)
  }
}
